export type WordType = 'people' | 'action' | 'describe' | 'thing' | 'social' | 'question' | 'little';

export type TalkWord = { id: string; word: string; picture: string; type: WordType };

export type Category = { id: string; label: string; picture: string; words: TalkWord[] };

const w = (word: string, picture: string, type: WordType): TalkWord => ({ id: `${type}:${word}`, word, picture, type });

export const CORE: TalkWord[] = [
  w('I', '🙋', 'people'),
  w('you', '👉', 'people'),
  w('want', '🤲', 'action'),
  w('like', '👍', 'action'),
  w("don't", '🚫', 'little'),
  w('more', '➕', 'describe'),
  w('help', '🆘', 'action'),
  w('stop', '✋', 'action'),
  w('go', '🟢', 'action'),
  w('finished', '🏁', 'describe'),
  w('yes', '✅', 'social'),
  w('no', '❌', 'social'),
];

export const CATEGORIES: Category[] = [
  { id: 'need', label: 'I need', picture: '🙋', words: [
    w('break', '🛑', 'thing'), w('toilet', '🚽', 'thing'), w('snack', '🍪', 'thing'),
    w('hug', '🤗', 'thing'), w('tickle', '🤭', 'thing'), w('water', '💧', 'thing'),
  ].map((x) => ({ ...x, id: `need:${x.word}` })) },
  { id: 'food', label: 'Food', picture: '🍎', words: [
    w('apple', '🍎', 'thing'), w('banana', '🍌', 'thing'), w('bread', '🍞', 'thing'), w('cheese', '🧀', 'thing'),
    w('biscuit', '🍪', 'thing'), w('crisps', '🥔', 'thing'), w('pasta', '🍝', 'thing'), w('pizza', '🍕', 'thing'),
    w('yoghurt', '🥣', 'thing'), w('grapes', '🍇', 'thing'), w('chicken', '🍗', 'thing'), w('cake', '🍰', 'thing'),
  ] },
  { id: 'drink', label: 'Drinks', picture: '🥤', words: [
    w('water', '💧', 'thing'), w('milk', '🥛', 'thing'), w('juice', '🧃', 'thing'), w('hot chocolate', '☕', 'thing'),
    w('cup', '🥤', 'thing'), w('bottle', '🍼', 'thing'),
  ] },
  { id: 'play', label: 'Play', picture: '⚽', words: [
    w('ball', '⚽', 'thing'), w('bubbles', '🫧', 'thing'), w('blocks', '🧱', 'thing'), w('tablet', '📱', 'thing'),
    w('music', '🎵', 'thing'), w('book', '📚', 'thing'), w('swing', '🛝', 'thing'), w('puzzle', '🧩', 'thing'),
    w('drawing', '🖍️', 'thing'), w('car', '🚗', 'thing'), w('teddy', '🧸', 'thing'), w('outside', '🌳', 'thing'),
  ] },
  { id: 'feel', label: 'Feelings', picture: '🙂', words: [
    w('happy', '😀', 'describe'), w('sad', '😢', 'describe'), w('angry', '😠', 'describe'), w('scared', '😨', 'describe'),
    w('tired', '😴', 'describe'), w('hurt', '🤕', 'describe'), w('too loud', '🔊', 'describe'), w('calm', '😌', 'describe'),
    w('hungry', '🍽️', 'describe'), w('thirsty', '💧', 'describe'), w('hot', '🥵', 'describe'), w('cold', '🥶', 'describe'),
  ] },
  { id: 'people', label: 'People', picture: '👨‍👩‍👧', words: [
    w('mum', '👩', 'people'), w('dad', '👨', 'people'), w('teacher', '🧑‍🏫', 'people'), w('friend', '🧒', 'people'),
    w('grandma', '👵', 'people'), w('grandad', '👴', 'people'), w('brother', '👦', 'people'), w('sister', '👧', 'people'),
  ] },
  { id: 'actions', label: 'Actions', picture: '🏃', words: [
    w('eat', '🍴', 'action'), w('drink', '🥤', 'action'), w('play', '🎲', 'action'), w('look', '👀', 'action'),
    w('open', '📦', 'action'), w('give', '🤝', 'action'), w('wait', '⏳', 'action'), w('sleep', '🛏️', 'action'),
    w('toilet', '🚽', 'action'), w('wash', '🧼', 'action'), w('walk', '🚶', 'action'), w('sit', '🪑', 'action'),
  ] },
  { id: 'places', label: 'Places', picture: '🏠', words: [
    w('home', '🏠', 'thing'), w('school', '🏫', 'thing'), w('park', '🛝', 'thing'), w('shop', '🛒', 'thing'),
    w('car', '🚗', 'thing'), w('bed', '🛏️', 'thing'), w('garden', '🌻', 'thing'), w('bathroom', '🛁', 'thing'),
  ] },
  { id: 'chat', label: 'Chat', picture: '💬', words: [
    w('hello', '👋', 'social'), w('bye', '👋', 'social'), w('please', '🙏', 'social'), w('thank you', '💐', 'social'),
    w('my turn', '☝️', 'social'), w('your turn', '👉', 'social'), w('what?', '❓', 'question'), w('where?', '📍', 'question'),
    w('who?', '🧑', 'question'), w('when?', '🕐', 'question'), w('I need a break', '🛑', 'social'), w('again', '🔁', 'describe'),
  ] },
];

export const TYPE_LABEL: Record<WordType, string> = {
  people: 'People',
  action: 'Doing words',
  describe: 'Describing words',
  thing: 'Things',
  social: 'Social words',
  question: 'Questions',
  little: 'Little words',
};
